<template>
  <div class="create-journey-container">
    <header class="create-journey-header">
      <div class="row">
        <div class="col-2 align-self-center">
          <router-link to="user-journey" class="p-2">
            <img
              src="@/assets/img/icons/chevron-left.svg"
              height="20"
              width="20"
            />
            <span>Back</span>
          </router-link>
        </div>
        <div class="col-4">
          <input
            type="text"
            v-model="user_journey_name"
            placeholder="Journey Name"
            class="form-control rounded-10"
            style="height:45px;"
          />
        </div>

        <!-- <div class="col-2">
          <div class="searchbar-rounded">
            <input type="search" placeholder="Search" />
          </div>
        </div> -->

        <div class="col-4 align-self-center">
          <div class="d-table ml-auto">
            <button
              class="btn btn-transparent mr-3"
              @click="onFinalSubmit('Draft')"
            >
              <img
                src="@/assets/img/icons/download.svg"
                height="18"
                width="18"
              />
              <span class="fs-14">&nbsp; SAVE AS DRAFT</span>
            </button>
            <button
              @click="onFinalSubmit('Complete')"
              class="btn btn-blue mx-0"
            >
              <img
                src="@/assets/img/icons/external-link.svg"
                height="18"
                width="18"
              />
              <span class="fs-14"
                >&nbsp;
                {{ journey_status === "Complete" ? "EDIT" : "PUBLISH" }}</span
              >
            </button>
          </div>
        </div>
      </div>
    </header>

    <div class="journey-left-sidebar">
      <div class="joruney-shadow">
        <div class="searchbar-rounded">
          <b-form-input
            v-debounce:500="onSearch"
            v-model="searchValue"
            placeholder="Search Controls"
          ></b-form-input>
        </div>

        <!-- TRIGGERS -->
        <section class="element-section">
          <button v-b-toggle.tirggers class="btn-element-toggle"
            >Triggers</button
          >
          <b-collapse visible class id="tirggers">
            <div class="row">
              <div
                class="col-4"
                :key="triggerKey"
                v-on:click="addElement(triggers, 'Trigger', triggerKey)"
                v-for="(triggers, triggerKey) in triggersList"
              >
                <div class="element-box">
                  <div class="element-icon">
                    <img :src="triggers.icon_url" class="img-padding" />
                  </div>
                  <div>{{ triggers.event_name }}</div>
                </div>
              </div>
            </div>
          </b-collapse>
        </section>

        <!-- ACTIONS -->
        <section class="element-section">
          <button v-b-toggle.actions class="btn-element-toggle">Actions</button>
          <b-collapse id="actions" visible>
            <div class="row">
              <div
                class="col-4"
                :key="actionsKey"
                v-on:click="addElement(actions, 'Action', actionsKey)"
                v-for="(actions, actionsKey) in actionsList"
              >
                <div class="element-box">
                  <div class="element-icon">
                    <img :src="actions.icon_url" class="img-padding" />
                  </div>
                  <p>{{ actions.action_name }}</p>
                </div>
              </div>
            </div>
          </b-collapse>
        </section>

        <!-- CONDITIONS -->
        <section class="element-section">
          <button v-b-toggle.conditions class="btn-element-toggle"
            >Conditions</button
          >
          <b-collapse
            id="conditions"
            :visible="isSearch && conditionsList.length > 0"
          >
            <div class="row">
              <div
                class="col-4"
                :key="conditionsListKey"
                v-on:click="
                  addElement(condition, 'Condition', conditionsListKey)
                "
                v-for="(condition, conditionsListKey) in conditionsList"
              >
                <div class="element-box">
                  <div class="element-icon">
                    <img :src="condition.icon_url" class="img-padding" />
                  </div>
                  <div>{{ condition.condition_name }}</div>
                </div>
              </div>
            </div>
          </b-collapse>
        </section>

        <!-- FLOW CONTROL -->
        <section class="element-section border-0">
          <button v-b-toggle.flowControl class="btn-element-toggle"
            >Flow Control</button
          >
          <b-collapse
            class
            id="flowControl"
            :visible="isSearch && flowControlsList.length > 0"
          >
            <div class="row">
              <div
                class="col-4"
                :key="flowControlKey"
                v-on:click="
                  addElement(flowControl, 'Flow Control', flowControlKey)
                "
                v-for="(flowControl, flowControlKey) in flowControlsList"
              >
                <div class="element-box">
                  <div class="element-icon">
                    <img :src="flowControl.icon_url" class="img-padding" />
                  </div>
                  <p>{{ flowControl.flow_control_name }}</p>
                </div>
              </div>
            </div>
          </b-collapse>
        </section>
      </div>
    </div>

    <div class="journey-center-content">
      <SimpleFlowchart
        :scene.sync="location"
        :height="canvasHeight"
        @nodeClick="nodeClick"
      ></SimpleFlowchart>
    </div>
    <div
      class="journey-right-sidebar"
      :class="rightSideBar ? 'is-active' : null"
    >
      <div class="position-relative p-3">
        <button
          class="btn-close-right-sidebar"
          v-on:click="rightSideBar = !rightSideBar"
        >
          <span>&times;</span>
        </button>

        <header>
          <div class="mr-2">
            <img
              src="@/assets/img/icons/user-attribute.svg"
              height="40"
              width="40"
            />
          </div>
          <span>User Attribute</span>
        </header>

        <!-- EMAIL ACTIONS -->
        <div v-if="selectedType == 2">
          <div v-if="selectedActionId == 1">
            <form v-on:submit.prevent>
              <div class="border-bottom">
                <button v-b-toggle.emailCampaign class="btn-element-toggle"
                  >Email Template</button
                >
                <b-collapse class id="emailCampaign">
                  <div class="row">
                    <div class="col-12 mb-3">
                      <div class="dropdown-curve-container mr-2">
                        <label
                          :class="
                            currentAttributes.email_template ? 'shift-up' : ''
                          "
                          >{{ $t("select") }} {{ $tc("template", 1) }}</label
                        >
                        <b-dropdown
                          :text="currentAttributes.email_template"
                          variant="dropdown-curve"
                          class="w-100"
                        >
                          <b-dropdown-item
                            v-for="(dropdownItem,
                            dropdownIndex) in emailCampaigns"
                            :key="dropdownIndex"
                            @click.prevent.stop="
                              DropDownHandler(
                                $event,
                                'emailTemplate',
                                dropdownItem,
                                dropdownIndex
                              )
                            "
                            >{{ dropdownItem.et_description }}</b-dropdown-item
                          >
                        </b-dropdown>
                      </div>
                    </div>
                  </div>
                  <p class="error_message pl-4">
                    <span
                      v-if="
                        submitted &&
                          currentAttributes.email_template.length == 0
                      "
                      >Please Select Template</span
                    >
                  </p>
                </b-collapse>
              </div>

              <button v-b-toggle.emailAddress class="btn-element-toggle"
                >Sender Email Address</button
              >
              <b-collapse class id="emailAddress">
                <div class="row">
                  <div class="col-12 mb-3">
                    <input
                      type="email"
                      @change.prevent.stop="
                        onChangeValue($event, 'email_address')
                      "
                      v-model="currentAttributes.email_address"
                      v-validate="'required|email'"
                      name="Email"
                      class="form-control form-control-sm"
                      placeholder="Sender Email Address"
                    />
                  </div>
                  <p class="error_message pl-4">
                    <span v-if="errors.has('Email')">{{
                      errors.first("Email")
                    }}</span>
                  </p>
                </div>
              </b-collapse>
            </form>
          </div>
          <!-- SMS -->
          <div v-if="selectedActionId == 2">
            <div class="border-bottom">
              <button v-b-toggle.smsTemplate class="btn-element-toggle"
                >Sms Template</button
              >
              <b-collapse class id="smsTemplate">
                <div class="row">
                  <div class="col-12 mb-3">
                    <div class="dropdown-curve-container mr-2">
                      <label
                        :class="currentAttributes.smsTemplate ? 'shift-up' : ''"
                        >{{ $t("select") }} {{ $tc("template", 1) }}</label
                      >
                      <b-dropdown
                        :text="currentAttributes.smsTemplate"
                        variant="dropdown-curve"
                        class="w-100"
                      >
                        <b-dropdown-item
                          v-for="(dropdownItem, dropdownIndex) in smsTemplates"
                          :key="dropdownIndex"
                          @click.prevent.stop="
                            DropDownHandler(
                              $event,
                              'smsTemplate',
                              dropdownItem,
                              dropdownIndex
                            )
                          "
                          >{{ dropdownItem.sms_temp_name }}</b-dropdown-item
                        >
                      </b-dropdown>
                    </div>
                  </div>
                  <p class="error_message pl-4">
                    <span
                      v-if="
                        submitted && currentAttributes.smsTemplate.length == 0
                      "
                      >Please Select Template</span
                    >
                  </p>
                </div>
              </b-collapse>
            </div>

            <button v-b-toggle.smsAddress class="btn-element-toggle"
              >Sender Sms Number</button
            >
            <b-collapse class id="smsAddress">
              <div class="row">
                <div class="col-12 mb-3">
                  <input
                    type="number"
                    @change.prevent.stop="onChangeValue($event, 'sms_number')"
                    v-model="currentAttributes.sms_number"
                    name="SMS Number"
                    v-validate="'required|numeric|min:7'"
                    class="form-control form-control-sm"
                    placeholder="Sms Number"
                  />
                </div>
                <p class="error_message pl-4">
                  <span v-if="errors.has('SMS Number')">{{
                    errors.first("SMS Number")
                  }}</span>
                </p>
              </div>
            </b-collapse>
          </div>
          <!-- SEGMENTS -->
          <div v-if="selectedActionId == 3">
            <button v-b-toggle.segment class="btn-element-toggle"
              >Segment</button
            >
            <b-collapse class id="segment">
              <div class="row">
                <div class="col-12 mb-3">
                  <div class="dropdown-curve-container mr-2">
                    <label :class="currentAttributes.segment ? 'shift-up' : ''"
                      >{{ $t("select") }} {{ $tc("segment", 1) }}</label
                    >
                    <b-dropdown
                      :text="currentAttributes.segment"
                      variant="dropdown-curve"
                      class="w-100"
                    >
                      <b-dropdown-item
                        v-for="(dropdownItem, dropdownIndex) in segments"
                        :key="dropdownIndex"
                        @click.prevent.stop="
                          DropDownHandler(
                            $event,
                            'segment',
                            dropdownItem,
                            dropdownIndex
                          )
                        "
                        >{{ dropdownItem.segment_name }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                </div>
                <p class="error_message pl-4">
                  <span
                    v-if="submitted && currentAttributes.segment.length == 0"
                    >Please Select Segment</span
                  >
                </p>
              </div>
            </b-collapse>
          </div>
        </div>

        <div v-if="selectedType == 4" class="pb-3">
          <div v-if="selectedActionId == 1">
            <div class="pb-3">
              <div class="row">
                <div class="col-12 mb-3">
                  <label :class="'shift-up'"
                    >{{ $t("wait") }} {{ $t("for") }}</label
                  >
                  <input
                    type="number"
                    @keyup.prevent.stop="onChangeValue($event, 'wait_value')"
                    v-model="currentAttributes.wait_value"
                    name="Wait For"
                    v-validate="'required'"
                    class="form-control form-control-sm"
                    placeholder="Wait For"
                  />
                </div>
                <p class="error_message pl-4">
                  <span v-if="errors.has('Wait For')">{{
                    errors.first("Wait For")
                  }}</span>
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-12 mb-3">
                <div class="dropdown-curve-container mr-2">
                  <label
                    :class="currentAttributes.wait_period ? 'shift-up' : ''"
                    >{{ $t("select") }} {{ $tc("option", 1) }}</label
                  >
                  <b-dropdown
                    :text="currentAttributes.wait_period"
                    variant="dropdown-curve"
                    class="w-100"
                  >
                    <b-dropdown-item
                      v-for="(dropdownItem, dropdownIndex) in waitArray"
                      :key="dropdownIndex"
                      @click.prevent.stop="
                        DropDownHandler(
                          $event,
                          'waitPeriod',
                          dropdownItem,
                          dropdownIndex
                        )
                      "
                      >{{ dropdownItem }}</b-dropdown-item
                    >
                  </b-dropdown>
                </div>
              </div>
              <p class="error_message pl-4">
                <span
                  v-if="submitted && currentAttributes.wait_period.length == 0"
                  >Please Select Wait Period</span
                >
              </p>
            </div>
          </div>
          <div v-if="selectedActionId == 4">
            <div>
              <div class="d-flex align-items-center mb-4">
                <label class="mb-0 mr-2">{{ $t("Wait_till_show_date") }}</label>
                <b-form-checkbox
                  unchecked-value="N"
                  value="Y"
                  v-model="currentAttributes.wait_till_show_date"
                  name="check-button"
                  @change="onSelectWaitTillShowTime"
                  switch
                ></b-form-checkbox>
              </div>
              <div
                class="input-material"
                v-if="
                  !currentAttributes.wait_till_show_date ||
                    currentAttributes.wait_till_show_date == 'N'
                "
              >
                <div class="add-datepicker">
                  <Datepicker
                    :monday-first="true"
                    ref="programaticOpen"
                    v-model="currentAttributes.wait_date"
                    name="showstartdate"
                    @selected="onSelectDate"
                    id="showstartdate"
                    v-validate="'required'"
                    :disabledDates="{
                      to: new Date(Date.now() - 8640000),
                    }"
                  ></Datepicker>
                  <label :class="currentAttributes.wait_date ? 'active' : ''"
                    >Waiting Date</label
                  >
                </div>
              </div>
            </div>
          </div>
          <!-- Email To -->
        </div>

        <div v-if="selectedType == 3">
          <div v-if="selectedActionId == 3 || selectedActionId == 4">
            <div class="row">
              <div class="col-12 mb-3">
                <div class="dropdown-curve-container mr-2">
                  <label
                    :class="
                      currentAttributes.action_data_variable ? 'shift-up' : ''
                    "
                    >{{ $t("select") }} {{ $tc("option", 1) }}</label
                  >
                  <b-dropdown
                    :text="currentAttributes.action_data_variable"
                    variant="dropdown-curve"
                    class="w-100"
                  >
                    <b-dropdown-item
                      v-for="(dropdownItem, dropdownIndex) in actionDataTypes"
                      :key="dropdownIndex"
                      @click.prevent.stop="
                        DropDownHandler(
                          $event,
                          'action_data_variable',
                          dropdownItem,
                          dropdownIndex
                        )
                      "
                      >{{ dropdownItem.field_name }}</b-dropdown-item
                    >
                  </b-dropdown>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12 mb-3">
                <div class="dropdown-curve-container mr-2">
                  <label
                    :class="currentAttributes.condition_rule ? 'shift-up' : ''"
                    >{{ $t("select") }} {{ $tc("option", 1) }}</label
                  >
                  <b-dropdown
                    :text="currentAttributes.condition_rule"
                    variant="dropdown-curve"
                    class="w-100"
                  >
                    <b-dropdown-item
                      v-for="(dropdownItem, dropdownIndex) in conditionRules"
                      :key="dropdownIndex"
                      @click.prevent.stop="
                        DropDownHandler(
                          $event,
                          'condition_rule',
                          dropdownItem,
                          dropdownIndex
                        )
                      "
                      >{{ dropdownItem.condition_rule_name }}</b-dropdown-item
                    >
                  </b-dropdown>
                </div>
              </div>
            </div>

            <div>
              <div class="row">
                <div class="col-12 mb-3">
                  <label :class="'shift-up'"
                    >{{ $t("some") }} {{ $t("value") }}</label
                  >
                  <input
                    @keyup.prevent.stop="onChangeValue($event, 'action_value')"
                    v-model="currentAttributes.action_value"
                    class="form-control form-control-sm"
                    placeholder="Some Value"
                  />
                </div>
              </div>
            </div>
          </div>

          <div v-if="selectedActionId == 1">
            <button v-b-toggle.segment class="btn-element-toggle"
              >Segment</button
            >
            <b-collapse class id="segment">
              <div class="row">
                <div class="col-12 mb-3">
                  <div class="dropdown-curve-container mr-2">
                    <label :class="currentAttributes.segment ? 'shift-up' : ''"
                      >{{ $t("select") }} {{ $tc("segment", 1) }}</label
                    >
                    <b-dropdown
                      :text="currentAttributes.segment"
                      variant="dropdown-curve"
                      class="w-100"
                    >
                      <b-dropdown-item
                        v-for="(dropdownItem, dropdownIndex) in segments"
                        :key="dropdownIndex"
                        @click.prevent.stop="
                          DropDownHandler(
                            $event,
                            'segment',
                            dropdownItem,
                            dropdownIndex
                          )
                        "
                        >{{ dropdownItem.segment_name }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                </div>
              </div>
            </b-collapse>
          </div>

          <div v-if="selectedActionId == 2">
            <button v-b-toggle.trigger class="btn-element-toggle"
              >Trigger</button
            >
            <b-collapse class id="trigger">
              <div class="row">
                <div class="col-12 mb-3">
                  <div class="dropdown-curve-container mr-2">
                    <label :class="currentAttributes.trigger ? 'shift-up' : ''"
                      >{{ $t("select") }} {{ $tc("triger", 1) }}</label
                    >
                    <b-dropdown
                      :text="currentAttributes.trigger"
                      variant="dropdown-curve"
                      class="w-100"
                    >
                      <b-dropdown-item
                        v-for="(dropdownItem, dropdownIndex) in triggersList"
                        :key="dropdownIndex"
                        @click.prevent.stop="
                          DropDownHandler(
                            $event,
                            'trigger',
                            dropdownItem,
                            dropdownIndex
                          )
                        "
                        >{{ dropdownItem.event_name }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                </div>
              </div>
            </b-collapse>
            <div class="pt-2">
              <p>Has action occured?</p>
              <input
                type="radio"
                id="one"
                value="Yes"
                v-model="currentAttributes.has_action_occured"
              />
              <label for="one">Yes</label>
              <br />
              <input
                type="radio"
                id="two"
                value="No"
                v-model="currentAttributes.has_action_occured"
              />
              <label for="two">No</label>
            </div>
          </div>
        </div>

        <button
          @click.prevent.stop="onSaveAndContinue()"
          class="btn btn-blue w-100 ml-0 mt-3"
          >Save and Continue</button
        >
      </div>
    </div>
  </div>
</template>

<script>
  import SimpleFlowchart from "vue-simple-flowchart";
  import "vue-simple-flowchart/dist/vue-flowchart.css";
  import { mapState, mapGetters, mapActions } from "vuex";
  import UserJourneyService from "@/services/UserJourneyService";

  export default {
    data() {
      return {
        submitted: false,
        selectedType: 0,
        selectedId: 0,
        canvasHeight: 1024,
        rightSideBar: false,
        selectedActionId: null,
        userJourneyContainer: false,
        location: {
          centerX: 1024,
          centerY: 140,
          scale: 1,
          nodes: [
            // {
            //   id: 111,
            //   x: -700,
            //   y: -69,
            //   type: "Action",
            //   label: "test1"
            // },
            // {
            //   id: 222,
            //   x: -357,
            //   y: 80,
            //   type: "Script",
            //   label: "test2"
            // }
          ],
          links: [
            // {
            //   id: 111,
            //   from: 111, // node id the link start
            //   to: 222 // node id the link end
            // }
          ],
        },
        user_journey_name: "",
        // selectedCampaign: "",
        // selectedSmsTemplate: "",
        // selectedSegment: "",
        // selectedActionVariable: "",
        // selectedTriger: "",
        // selectedActionDataType: "",
        // selectedValue: "Yes",
        // selectedConditionRule: "",
        // selectedDate: new Date(),
        // sms_number: "",
        // action_value: "",
        // email_address: "",
        // wait_value: "",
        selectedWaitPeriod: "Days",
        waitArray: ["Minutes", "Hours", "Days", "Weeks", "Months", "Years"],
        currentAttributes: {},
        journey_status: undefined,
        searchValue: "",
        isSearch: false,
      };
    },
    computed: {
      ...mapGetters([
        "triggersList",
        "actionsList",
        "flowControlsList",
        "conditionsList",
        "emailCampaigns",
        "smsTemplates",
        "segments",
        "actionDataTypes",
        "conditionRules",
      ]),
    },
    beforeMount() {
      const { user_journey_id } = this.$route.query;
      if (user_journey_id) {
        this.user_journey_id = user_journey_id;
        this.fetchSingleUserJourneyData(user_journey_id);
      } else {
        this.$router.go(-1);
      }
    },
    mounted() {
      this.getTriggersList();
      this.getActionsList();
      this.getFlowControlsList();
      this.getConditionsList();
      this.getEmailCampaignList();
      this.getSmsTemplateList();
      this.getActionDataType();
      this.getConditionRules();
      this.getSegments();
      this.canvasHeight = window.innerHeight;
    },
    methods: {
      ...mapActions([
        "getTriggersList",
        "getActionsList",
        "getFlowControlsList",
        "getConditionsList",
        "getEmailCampaignList",
        "getSmsTemplateList",
        "getSegments",
        "getActionDataType",
        "getConditionRules",
        "onUpdateUserJourney",
        "onSearchControl",
      ]),
      onSearch() {
        this.onSearchControl(this.searchValue);
        if (this.searchValue) {
          this.isSearch = true;
        } else {
          this.isSearch = false;
        }
      },
      fetchSingleUserJourneyData: function(id) {
        UserJourneyService.GetSingleUserJourneyData(id)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              if (data.Records.length > 0) {
                let obj = data.Records[0].userJourney;
                this.user_journey_name = obj.user_journey_name;
                this.journey_status = obj.user_journey_status;
                // this.selectedCampaign = obj.selectedCampaign;
                // this.selectedSmsTemplate = obj.smsTemplate;
                // this.email_address = obj.email_address;
                // this.sms_number = obj.sms_number;
                // this.wait_value = obj.wait_value;
                // this.selectedWaitPeriod = obj.selectedWaitPeriod;
                // this.selectedConditionRule = obj.selectedConditionRule;
                // this.selectedActionVariable = obj.selectedActionVariable;
                // this.action_value = obj.action_value;
                // this.selectedTriger = obj.trigger;
                // this.selectedSegment = obj.segment;
                // this.selectedDate = obj.waitDate;
                //
                this.constructAttributesFromDataForNodes(data.Records[0].nodes);
                this.location.nodes = data.Records[0].nodes;
                this.location.links = data.Records[0].links;
              }
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            this.$toasted.show("Something went wrong");
          });
      },
      nodeClick(event) {
        let array = this.location.nodes.filter((x) => {
          return x.id == event;
        });
        if (array.length > 0) {
          let obj = array[0];
          console.log(obj);
          console.log("selectedId = ", this.selectedId);
          if (this.selectedId !== obj.id) {
            this.currentAttributes = {
              ...obj.attributes,
            };
            console.log("obj.attributes", obj.attributes);
            console.log("this.currentAttributes", this.currentAttributes);
          }

          if (obj.typeId == 2 || obj.typeId == 4) {
            this.rightSideBar = true;
            this.selectedType = obj.typeId;
            this.selectedId = event;
            this.selectedActionId = obj.action_id;
          }
          if (obj.typeId == 3) {
            this.rightSideBar = true;
            this.selectedType = obj.typeId;
            this.selectedId = event;
            this.selectedActionId = obj.action_id;
          }

          this.selectedId = event;
        }
      },
      addElement(item, itemType, key) {
        if (itemType == "Trigger") {
          this.location.nodes.push({
            x: -100,
            y: -100,
            id: Math.floor(1000 + Math.random() * 9000),
            typeId: 1,
            type: itemType,
            label: item.event_name,
            attributes: {},
          });
        } else if (itemType == "Action") {
          this.location.nodes.push({
            x: -100,
            y: -100,
            id: Math.floor(1000 + Math.random() * 9000),
            typeId: 2,
            type: itemType,
            action_id: item.action_id,
            label_id: item.action_id,
            label: item.action_name,
            data: [],
            attributes: {},
          });
        } else if (itemType == "Condition") {
          this.location.nodes.push({
            x: -100,
            y: -100,
            id: Math.floor(1000 + Math.random() * 9000),
            typeId: 3,
            type: itemType,
            action_id: item.condition_id,
            label: item.condition_name,
            label_id: item.condition_id,
            data: [],
            attributes: {},
          });
        } else if (itemType == "Flow Control") {
          this.location.nodes.push({
            x: -100,
            y: -100,
            id: Math.floor(1000 + Math.random() * 9000),
            typeId: 4,
            type: itemType,
            action_id: item.flow_control_id,
            label: item.flow_control_name,
            label_id: item.flow_control_id,
            data: [],
            attributes: {},
          });
        }
      },
      DropDownHandler(event, type, value, index) {
        if (type == "emailTemplate") {
          this.currentAttributes.email_template = value.et_description;
          this.currentAttributes.et_id = value.et_id;
        }
        //
        else if (type == "waitPeriod") {
          this.currentAttributes.wait_period = value;
        }
        //action_data_variable
        else if (type == "action_data_variable") {
          this.currentAttributes.action_data_variable = value.field_name;
          this.currentAttributes.adt_id = value.adt_id;
        }
        //condition_rule
        else if (type == "condition_rule") {
          this.currentAttributes.condition_rule = value.condition_rule_name;
          this.currentAttributes.cr_id = value.cr_id;
        }
        //
        else if (type == "smsTemplate") {
          this.currentAttributes.smsTemplate = value.sms_temp_name;
          this.currentAttributes.sms_id = value.sms_id;
        }
        //
        else if (type == "trigger") {
          this.currentAttributes.trigger = value.event_name;
          this.currentAttributes.trigger_id = value.trigger_id;
        }
        //
        else if (type == "segment") {
          this.currentAttributes.segment = value.segment_name;
          this.currentAttributes.csm_id = value.csm_id;
        }

        this.currentAttributes = {
          ...this.currentAttributes,
        };
      },
      onSelectDate: function(event) {
        this.currentAttributes = {
          ...this.currentAttributes,
          wait_date: event,
        };
      },
      onSelectWaitTillShowTime(event) {
        this.currentAttributes = {
          ...this.currentAttributes,
          wait_till_show_date: event,
        };
      },
      onSaveAndContinue: function() {
        this.submitted = true;
        this.$validator.validate().then((valid) => {
          if (valid) {
            let selectedNode = this.location.nodes.find(
              (node) => node.id === this.selectedId
            );
            if (selectedNode) {
              selectedNode.attributes = {
                ...selectedNode.attributes,
                ...this.currentAttributes,
              };
            }
            this.saveAttributesAsDataArray();
            this.submitted = false;
            this.rightSideBar = false;
            this.selectedType = "";
            this.selectedId = "";
          } else {
            return;
          }
        });
      },
      onSelectValue: function(event) {
        this.currentAttributes = {
          ...this.currentAttributes,
          has_action_occured: event.target.value,
        };
      },
      onChangeValue: function(event, type) {
        // let _index = this.location.nodes.findIndex(x => {
        //   return x.id == this.selectedId;
        // });
        // //
        // if (type == "email_address") {
        //   this.location.nodes[_index].data.push({
        //     data: "email_address",
        //     value: event.target.value
        //   });
        //   this.email_address = event.target.value;
        // }
        // //
        // else if (type == "wait_value") {
        //   this.location.nodes[_index].data.push({
        //     data: "wait_value",
        //     value: event.target.value
        //   });
        //   this.email_address = event.target.value;
        // }
        // //action_value
        // else if (type == "action_value") {
        //   this.location.nodes[_index].data.push({
        //     data: "action_value",
        //     value: event.target.value
        //   });
        //   this.action_value = event.target.value;
        // }
        //  else if (type == "sms_number") {
        //   this.location.nodes[_index].data.push({
        //     data: "sms_number",
        //     value: event.target.value
        //   });
        //   this.sms_number = event.target.value;
        // }
      },
      getNodesWithOrder() {
        let startNode = this.getStartingNode();
        if (this.getStartingNode()) {
          this.addNumberingToNode(startNode, 1);
        } else {
          //no start node
        }
      },
      addNumberingToNode(node, order) {
        //find node
        console.log(order);
        this.location.nodes = this.location.nodes.map((singleNode) => {
          if (singleNode.id == node.id) {
            singleNode.order = order;
          }
          return singleNode;
        });
        let childNodeID = "";
        let childNode = {};
        this.location.links.map((link) => {
          if (link.from == node.id) {
            childNodeID = link.to;
          }
        });
        this.location.nodes.map((singleNode) => {
          if (singleNode.id == childNodeID) {
            childNode = singleNode;
          }
        });

        if (childNodeID) {
          console.log("t1", childNode);
          this.addNumberingToNode(childNode, order + 1);
        } else {
          return node;
        }
      },
      getStartingNode() {
        let newNode = this.location.nodes.map((node) => {
          this.location.links.map((x, index1) => {
            if (node.id == x.to) {
              node.exists = true;
            }
          });
          return node;
        });
        newNode = newNode.filter((node) => {
          return !node.exists;
        });
        if (newNode.length == 0) {
          //no parent
          return null;
        }
        if (newNode[0].typeId != "1") {
          // console.log("please select first item as trigger");
          this.$toasted.show("please select first item as trigger");
          return null;
        } else if (newNode.length > 1) {
          this.$toasted.show("please have a single chain");
          return null;
          console.log("please have a single chain");
        } else {
          return newNode[0];
        }
      },
      onFinalSubmit: function(status) {
        this.getNodesWithOrder();
        let response = this.getStartingNode();
        console.log("response :>> ", response);
        if (response == null) {
          console.log("object:::");
          return;
        }
        let payload = {
          user_journey_id: this.user_journey_id,
          user_journey_name: this.user_journey_name,
          status: status,
          user_journey_objects: this.location.nodes,
        };
        this.onUpdateUserJourney(payload);
      },
      constructAttributesFromDataForNodes: function(nodes) {
        nodes.forEach((node) => {
          if (node.data) {
            let attributes = {};
            node.data.forEach((d) => {
              attributes[d.data] = d.value;
            });
            node.attributes = attributes;
          }
        });
      },
      saveAttributesAsDataArray() {
        let selectedNode = this.location.nodes.find(
          (n) => n.id === this.selectedId
        );

        if (selectedNode) {
          let dataArr = [];
          Object.keys(selectedNode.attributes).forEach((key) => {
            if (key !== "id") {
              dataArr.push({
                data: key,
                value: selectedNode.attributes[key],
              });
            }
          });

          selectedNode.data = dataArr;
        }
      },
    },

    components: {
      SimpleFlowchart,
    },
  };
</script>

<style>
  .create-journey-container {
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    display: flex;
    z-index: 9999;
    position: fixed;
    min-height: 100vh;
    overflow: hidden;
    padding-top: 75px;
    background-color: #fff;
  }

  .create-journey-header {
    top: 0;
    left: 0;
    width: 100%;
    width: 100%;
    padding: 15px;
    z-index: 9999;
    position: fixed;
    background-color: #fff;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1);
  }

  .journey-left-sidebar {
    width: 320px;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 15px;
    height: calc(100vh - 65px);
    background-color: #dddddd;
  }

  .joruney-shadow {
    overflow: hidden;
    border-radius: 10px;
    padding: 15px 10px;
    background-color: #fff;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1);
  }

  .journey-center-content {
    width: calc(100% - 275px);
  }

  .journey-right-sidebar {
    top: 95px;
    width: 340px;
    right: -340px;
    z-index: 99999;
    position: fixed;
    border-radius: 10px;
    background-color: #fff;
    transition: 0.2s ease-in-out;
    border-left: 1px solid #d3d3d3;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1);
  }

  .journey-right-sidebar.is-active {
    right: 15px;
  }

  .journey-right-sidebar header {
    display: flex;
    align-items: center;
    padding-bottom: 10px;
    margin-bottom: 10px;
    /* border-bottom: 1px solid #d3d3d340; */
  }

  .journey-right-sidebar header .icon {
    width: 40px;
    height: 40px;
    overflow: hidden;
    margin-right: 15px;
    border-radius: 5px;
  }

  .btn-close-right-sidebar {
    /*top: -10px;*/
    top: 10px;
    width: 30px;
    height: 30px;
    /*right: -10px;*/
    right: 10px;
    color: #fff;
    line-height: 1;
    font-size: 20px;
    border-radius: 5px;
    position: absolute;
    transition: 0.2s ease;
    background-color: #ff6457;
  }

  .btn-close-right-sidebar span {
    font-size: 27px;
  }

  .btn-close-right-sidebar:hover {
    transform: scale(1.1);
  }

  .journey-right-sidebar .input-material {
    height: 31px;
    min-height: 31px;
  }

  .journey-right-sidebar .input-material input {
    min-height: 31px;
    border-radius: 5px;
  }

  .journey-right-sidebar .add-datepicker input::placeholder {
    color: var(--dark);
  }

  .journey-right-sidebar .vdp-datepicker__calendar {
    top: 35px;
  }
  .btn-element-toggle {
    width: 100%;
    border: none;
    font-size: 14px;
    text-align: left;
    padding: 15px 10px;
    border-radius: 3px;
    position: relative;
    background-color: #fff;
  }

  .btn-element-toggle::after {
    content: "";
    width: 7.5px;
    right: 15px;
    height: 7.5px;
    display: block;
    position: absolute;
    top: calc(50% - 6px);
    transition: 0.2s ease;
    transform: rotate(225deg);
    border-top: 1px solid #000;
    border-left: 1px solid #000;
  }

  .btn-element-toggle:not(.collapsed):after {
    top: calc(50% - 2.5px);
    transform: rotate(45deg);
  }

  .element-section {
    border-bottom: 1px solid #d3d3d3;
  }

  .element-box {
    font-size: 12px;
    text-align: center;
    margin-bottom: 25px;

    transition: 0.2s ease;
  }

  .element-icon {
    width: 50px;
    height: 50px;
    margin: 0 auto;
    overflow: hidden;
    border-radius: 10px;
    background-color: #d6e7ff;
  }

  .element-box p {
    font-size: 11px;
    padding-top: 5px;
    margin-bottom: 0;
    text-transform: capitalize;

    overflow: hidden;
    max-height: 40px;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .element-box:hover {
    color: var(--lightgrey);
    background-color: #fff;
    border-color: var(--lightgrey);
    transform: scale(1.075);
  }

  /* PLUGIN CUSTOMIZATION */

  .journey-center-content .flowchart-node .node-delete {
    font-size: 20px;
    line-height: 1;
    height: 20px;
    left: -7.5px;
    top: -7.5px;
    width: 20px;
    color: #fff;
    background-color: #ff6457;
    transition: 0.2s ease;
    border-radius: 5px !important;
    border: none !important;
  }

  .journey-center-content .flowchart-node.selected {
    box-shadow: 0 0 0 2px var(--lightgrey);
  }

  .journey-center-content .flowchart-node .node-type {
    min-width: 60px;
    display: flex;
    align-items: center;
    border-radius: 12px;
    margin-right: 10px;
    padding: 5px;
    color: var(--lightgrey) !important;
    justify-content: center;
    background-color: #d6e7ff !important;
  }
  .journey-center-content .flowchart-node .node-delete:hover {
    color: #fff;
    background-color: var(--danger);
  }

  .journey-center-content .flowchart-node,
  .journey-center-content .node-main {
    border-radius: 10px !important;
  }

  .journey-center-content .flowchart-node {
    padding: 10px;
    border-radius: 10px;
    width: 200px !important;
    max-width: 200px !important;
    min-width: 200px !important;
    transform: translateX(-60px) scale(1) !important;
  }

  .journey-center-content .node-main {
    height: 100%;
  }

  .journey-center-content .node-main {
    display: flex;
  }

  .journey-center-content .node-label {
    text-align: left;
    align-self: center;
    text-transform: capitalize;
  }

  .flowchart-container svg g path {
    stroke: #4683e0 !important;
  }
  .img-padding {
    width: 50px;
    padding: 5px;
  }
  #showstartdate {
    min-height: 40px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/MarketingAutomationContainer/UserJourneyComponents/editUserJourney.vue